// 深色
const darkTheme = {
  '--bg_white_1': '#2B2E30',
  '--bg_grey_1': '#252829',
  '--bg_grey_2': '#252728',
  '--bg_stroke_grey_3_1': '#434346',
  '--bg_stroke_grey_3_2': '#2F3031',
  '--bg_stroke_grey_3_16': '#2F3031',
  '--bg_stroke_grey_3_4': '#2F3031',
  '--bg_stroke_grey_3_5': '#2F3031',
  '--bg_bt_black_1': 'rgba(255, 255, 255, 0.80)',
  '--bg_floating_white_1': '#363739',
  '--bg_pop_white_1': '#1E1F20',
  '--bg_idea_blue_1': '#1E1F20',
  '--hover_icon_grey_1': '#434346',
  '--hover_icon_grey_2': '#434346',
  '--tips_toast_black_1': '#434346',
  '--bg_blue_1': '#1946E3',
  '--bg_blue_2': '#434346',
  '--bg_chat_white_2': 'rgba(30, 31, 32, 0.90)',
  '--bg_lable_grey_2': '#545459',
  '--tips_toast_stroke_grey_1': '#434346',
  '--floating_stroke_grey_1': '#27292C',
  '--box_stroke_grey_1': '#545459',
  '--box_stroke_black_2': 'rgba(255, 255, 255, 0.50)',
  '--bt_stroke_black_1': '#626267',
  '--txt_stroke_blue_1': '#386FFF',
  '--txt_icon_black_1': 'rgba(255, 255, 255, 0.95)',
  '--txt_icon_black_2': 'rgba(255, 255, 255, 0.70)',
  '--txt_icon_grey_3': 'rgba(255, 255, 255, 0.50)',
  '--txt_icon_grey_4': 'rgba(255, 255, 255, 0.30)',
  '--txt_icon_grey_5': 'rgba(255, 255, 255, 0.50)',
  '--txt_icon_grey_6': 'rgba(255, 255, 255, 0.30)',
  '--txt_icon_white_7': '#FFFFFF',
  '--txt_icon_grey_6_x': 'rgba(255, 255, 255, 0.30)',
  '--bg_stroke_grey_3_2(x)': '#2F3031',
  '--mask_white_1': 'rgba(26, 32, 41, 0.12)',
  '--hover_bt_blue_1': '#0133E3',
  '--glm4_lable_black_1': '#545459',
  '--search_blue_1': '#5F6BD5',
  '--search_txt_blue_1': '#5F6BD5',
  '--warn_lable_red_1': '#D1BDBA',
  '--warn_red_1': '#A9433C',
  '--hover_warn_red_1': '#C51515',
  '--warn_lable_red_2': '#A9433C',
  '--warn_lable_yellow_1': '#A76222',
  '--warn_lable_yellow_2': '#E2AF2F',
  '--right_lable_green_1': '#31BC3F',
  '--right_txt_green_1': '#13A018',
  '--angent_special_grey_1': '#37393B',
  '--angent_special_grey_2': '#434346',
  '--bg_chat_box_grey_1': '#434346',
  '--stroke_chat_box_grey_1': '#434346',
  '--bg_angent_chat_grey_1': '#434346',
  '--agent_guide_shadow': 'rgba(19, 19, 20, 0.20)',
  '--stroke_chat_box_grey_2': 'rgba(47, 48, 49, 0.70)',
  '--el-radio-input-border': '1px solid #434346',
  '--bg_goods': 'rgba(255, 255, 255, 0.06)',
  '--bg_goods_new': 'rgba(255, 255, 255, 0.06)',
  '--box_shadow_1': 'rgba(17, 49, 95, 0.08)',
  '--el-skeleton-bgcolor': '#626267',
  '--float_List': '#545459',
  '--agent_bg_panel': '#434346',
  '--selection_bg_blue': '#434346',
  '--box_new_boxshadow': 'rgba(19, 19, 20,0.7)',
  '--chat_box_shadow_1': '#131314',
  '--angent_special_grey_3': 'rgba(255, 255, 255, 0.15)',
  '--vip_box_stroke_1': '#434346',
  '--vip_box_bg_1': '#2F3031',
  '--linear_bg_rate': 'linear-gradient(90deg, #4B535F 0%, #57606E 99.63%)',
  '--linear_bg_rate_2': 'linear-gradient(90deg, #D6D9E1 0%, #C29594 100%)',
  '--bg_chat_white_3': 'rgba(30, 31, 32, 0.90)',
  '--bg_shadow': 'rgba(0, 0, 0, 0.10)',
  '--chat_box_shadow_2': ' rgba(19, 19, 20, 0.2)',
  '--bg_chat_white_4': 'rgba(255, 255, 255, 0.50)',
  '--txt-icon-grey-360': 'rgba(255, 255, 255, 0.50)',
  '--card_swiper_gradient_1': 'rgba(30, 31, 32, 0.00)',
  '--card_swiper_gradient_2': '#2B2E30',
  '--image_swiper_gradient_1': 'rgba(19, 19, 20, 0.00)',
  '--image_swiper_gradient_2': '#252829'
}
export default darkTheme
